//https://spin.atomicobject.com/2021/12/20/securing-api-gateway-aws-iam/
import axios from 'axios';
import { signRequest } from '../signatureV4/signRequestViaSdk';
// For some reason, axios default content-type is application/x-www-form-urlencoded
const defaultHeaders = {
    'Content-Type': 'application/json', // post only, gets removed in get
    //"Accept-Encoding": "gzip, deflate, br",
    'Cache-Control': 'no-cache',
};
export const getAxiosClient = ({ apiUrl, credentials, region }) => {
    const baseURL = apiUrl.origin;
    const client = axios.create({
        baseURL,
        headers: {
            host: apiUrl.hostname, // AWS signature V4 requires this header
            ...defaultHeaders,
            //   post: defaultHeaders,
            //   put: defaultHeaders,
            //   patch: defaultHeaders,
            //   get: defaultHeaders,
            //   options: defaultHeaders
        },
    });
    //delete client.defaults.headers.common['Accept']
    client.interceptors.request.use(async (requestConfig) => {
        // This is mainly for typescript's benefit; we expect method and url to be present
        if (!(requestConfig.method && requestConfig.url && requestConfig.headers && requestConfig.headers[requestConfig.method])) {
            throw new Error('Incomplete request');
        }
        const methodHeaders = (requestConfig.headers[requestConfig.method] ?? {});
        // Axios somewhat annoyingly separates headers by request method.
        // We need to merge them so we can include them in the signature.
        const inputHeaders = {
            ...methodHeaders,
            ...requestConfig.headers,
        };
        const hostHeader = { host: apiUrl.host };
        const signedRequest = await signRequest({
            headers: { ...inputHeaders, ...hostHeader },
            method: requestConfig.method,
            apiUrl,
            body: requestConfig.data,
            path: apiUrl.pathname,
            credentials,
            region,
        });
        const outputConfig = {
            ...requestConfig,
            headers: { ...signedRequest.headers, ...requestConfig.headers },
        };
        delete outputConfig.headers?.host; // xhr will refuse and show err in console
        return outputConfig;
    });
    return client;
};
